import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@/contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
    const { t } = useTranslation();
    const { isImpersonating, impersonation, exitImpersonation } = useContext(AuthContext);
    const [exiting, setExiting] = useState(false);

    if (!isImpersonating || !impersonation) return null;

    const handleExit = async () => {
        setExiting(true);
        try {
            await exitImpersonation();
            // Bounce to the admin user list — the admin's most likely next action.
            window.location.assign('/admin/users');
        } finally {
            setExiting(false);
        }
    };

    const target = impersonation.targetName?.trim()
        ? `${impersonation.targetName} (${impersonation.targetEmail})`
        : impersonation.targetEmail;

    return (
        <div className="bg-amber-400 text-amber-950 px-4 py-2 flex items-center justify-between gap-3 border-b border-amber-500 shadow-sm">
            <div className="text-sm font-medium">
                {t('admin.users.impersonate.banner', {
                    defaultValue: 'Inloggad som {{target}} — som admin {{admin}}.',
                    target,
                    admin: impersonation.adminEmail,
                })}
            </div>
            <button
                onClick={handleExit}
                disabled={exiting}
                className="text-sm font-semibold px-3 py-1 rounded bg-amber-950 text-amber-50 hover:bg-amber-900 disabled:opacity-50"
            >
                {exiting
                    ? t('admin.users.impersonate.exiting', 'Avslutar...')
                    : t('admin.users.impersonate.exit', 'Avsluta')}
            </button>
        </div>
    );
};

export default ImpersonationBanner;
